// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__2g2mV","bookmark":"Details_bookmark__1jSlg"};